import { ReportMealsTabReservedMeals, ReportMealsTabTakenMeals } from "@/components/report/meals";
import hasBarCompanies from "../../shared/hasBarCompanies";

/**
 * Stari tabovi u novoj ljusci (računar) bez svojih izbora firme i smena: firmu i smene biraju u zajedničkoj
 * traci iznad izveštaja, isto kao u ostalim izveštajima. Tab zadržava svoje učitavanje, tabele, štampu i Excel.
 * Izbor smena iz trake stiže kao prop `shiftFilter` (ime `shifts` je zauzeto podacima starih tabova).
 */
const bindsShifts = {
  props: {
    shiftFilter: {
      type: Array,
      default: () => [1, 2, 3, 4],
    },
  },
  watch: {
    shiftFilter: {
      handler(shifts) {
        this.selectedShifts = [...shifts];
      },
      immediate: true,
    },
  },
};

const withoutOwnFilters = {
  computed: {
    hasOwnFilters() {
      return false;
    },
  },
};

/** Preuzeti obroci: firme iz trake (izbor iz store-a), smene iz trake. */
export const ReportDesktopTakenMeals = {
  name: "ReportDesktopTakenMeals",
  extends: ReportMealsTabTakenMeals,
  mixins: [bindsShifts, withoutOwnFilters, hasBarCompanies],
};

/** Rezerve: firme iz trake (tab ih već čita iz store-a). */
export const ReportDesktopReserved = {
  name: "ReportDesktopReserved",
  extends: ReportMealsTabReservedMeals,
  mixins: [withoutOwnFilters],
};
